import type {
  InvoicePoMatchingsResponseType,
  PODetailsInInvoiceType,
} from 'features/Enterprise/Vendor/services/vendorInvoice'

export const resolveInvoicePurchaseOrderId = (purchaseOrder: PODetailsInInvoiceType): number =>
  purchaseOrder.invoice_purchase_order_id ?? purchaseOrder.id

export const resolveInvoicePurchaseOrderIdForApi = (
  purchaseOrder: PODetailsInInvoiceType,
  matchings?: InvoicePoMatchingsResponseType | null,
): number =>
  matchings?.invoice_purchase_order_id ??
  purchaseOrder.invoice_purchase_order_id ??
  purchaseOrder.id
